module.exports = __webpack_public_path__ + "img/Wikidata-logo-en.719c95b3.png";